import React from 'react';
import { Divider } from 'antd';

export const PEAR_COLORS = [
  { name: 'P', hex: '#03a9f4' }, // turquoise (fresh, not greenish like avoided one)
  { name: 'A', hex: 'lightgrey' }, // dark navy blue
  { name: 'I', hex: 'pink' }, // strong orange (not yellowish)
  { name: 'R', hex: 'green' },
  { name: 'S', hex: 'maroon' },
];

const DOT_STYLE = {
  width: 8,
  height: 8,
  marginRight: 5,
  borderRadius: 2,
  display: 'block',
};

const LEGENDS = [
  { dot: '#6bc950', label: '#6bc950', text: 'Available (A)' },
  { dot: 'red', label: 'red', text: 'In Business (I)' },
  { dot: '#a87d52', label: '#a87d52', text: 'Bid (B)' },
  { dot: '#c950c1', label: '#c950c1', text: 'New Arrival (U)' },
  { dot: '#074eb8', label: '#074eb8', text: 'Other Location' },
  // { dot: 'pink', label: 'pink', text: 'Bid/Show (BS)' },
  { dot: '#fbb80f', label: '#fbb80f', text: 'Show (S)' },
];

export const AllStatusShow = (props) => {
  const [showPearMenu, setShowPearMenu] = React.useState(false);
  return (
    <ul
      style={{
        listStyle: 'none',
        padding: 0,
        margin: 0,
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px 6px',
        alignItems: 'center',
      }}
    >
      {!props?.show && (
        <>
          {LEGENDS.slice(0, 2).map((l, i) => (
            <React.Fragment key={i}>
              {i > 0 && (
                <li style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
                  <Divider type="vertical" style={{ margin: '0 8px' }} />
                </li>
              )}
              <li style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ ...DOT_STYLE, background: l.dot }} />
                <span style={{ color: l.label, fontWeight: 600 }}>{l.text}</span>
              </li>
            </React.Fragment>
          ))}
          <li style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
            <Divider type="vertical" style={{ margin: '0 1px' }} />
          </li>
          <li
            style={{ position: 'relative', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            onMouseEnter={() => setShowPearMenu(true)}
            onMouseLeave={() => setShowPearMenu(false)}
          >
            <span style={{ fontWeight: 600 }}>
              {'PAIRS'.split('').map((char, i) => (
                <span key={`${char}-${i}`} style={{ color: PEAR_COLORS[i % PEAR_COLORS.length].hex }}>
                  {char}
                </span>
              ))}
            </span>
            {showPearMenu && (
              <div
                style={{
                  position: 'absolute',
                  left: 0,
                  top: '100%',
                  // marginTop: 6,
                  background: '#fff',
                  border: '1px solid #ddd',
                  borderRadius: 8,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  padding: '10px 12px',
                  minWidth: 180,
                  zIndex: 1000,
                }}
                onMouseEnter={() => setShowPearMenu(true)}
                onMouseLeave={() => setShowPearMenu(false)}
              >
                <div style={{ fontSize: 12, fontWeight: 600, color: '#666', marginBottom: 6 }}>Available colors</div>
                <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
                  {PEAR_COLORS.map((c) => (
                    <span
                      key={c.hex}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 4,
                        fontSize: 12,
                        color: '#666',
                      }}
                    >
                      <span
                        style={{
                          width: 14,
                          height: 14,
                          borderRadius: 4,
                          background: c.hex,
                          border: '1px solid rgba(0,0,0,0.1)',
                        }}
                      />
                      <span style={{ fontSize: 10, fontWeight: 600 }}>{c.name}</span>
                    </span>
                  ))}
                </div>
              </div>
            )}
          </li>
          {LEGENDS.slice(2, 6).map((l, i) => (
            <React.Fragment key={i}>
              <li style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
                <Divider type="vertical" style={{ margin: '0 8px' }} />
              </li>
              <li style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ ...DOT_STYLE, background: l.dot }} />
                <span style={{ color: l.label, fontWeight: 600 }}>{l.text}</span>
              </li>
            </React.Fragment>
          ))}
        </>
      )}
      {props?.show && (
        <li style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ ...DOT_STYLE, background: LEGENDS[4].dot }} />
          <span style={{ color: LEGENDS[4].label, fontWeight: 600 }}>{LEGENDS[4].text}</span>
        </li>
      )}
      {/* <li style={{ display: 'flex', alignItems: 'center', padding: 0 }}>
        <Divider type="vertical" style={{ margin: '0 8px' }} />
      </li> */}
      {/* <li style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ ...DOT_STYLE, background: LEGENDS[5].dot }} />
        <span style={{ color: LEGENDS[5].label, fontWeight: 600 }}>{LEGENDS[5].text}</span>
      </li> */}
    </ul>
  );
};
